import React from 'react';
import styled, { css } from 'styled-components';

export default styled(({ className, value }) => (
  <div className={className}>{value}</div>
))`
  ${({ strong = false }) => strong && css`
    font-weight: bold;
  `}
  ${({ small = false }) => small && css`
    font-size: 75%;
  `}

  a {
    color: inherit;
  }
`;
